// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4b-1";
export var standaloneTable = "_4b-0";